import { loadStripe, type Stripe } from "@stripe/stripe-js";

// 3f 2d-ii Step 2b: per-ORG Stripe.js. The publishable key must match the org's mode (test for
// demo, live for AP) — a single build-time key broke client-side card setup on test-mode orgs
// (live key vs a test-mode SetupIntent client_secret). Callers pass the active org's publishable
// key (resolved from billing_config). We cache PER KEY so a multi-org admin who switches orgs
// never gets a stale, wrong-org Stripe instance (same per-org isolation principle as the fix).
// Falls back to the build-time env key when no key is supplied (protects orgs whose billing_config
// has no publishable key from regressing).
const stripeByKey = new Map<string, Promise<Stripe | null>>();

export function getStripe(publishableKey?: string | null): Promise<Stripe | null> {
  const key = publishableKey || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  if (!key) {
    console.warn("[Stripe] No publishable key (org + env both empty) — card features disabled");
    return Promise.resolve(null);
  }
  let promise = stripeByKey.get(key);
  if (!promise) {
    console.log("[Stripe] Key prefix:", key.slice(0, 12));
    promise = loadStripe(key);
    stripeByKey.set(key, promise);
  }
  return promise;
}
